export default {
  生产物料: "生產性物料",
  非生产物料: "非生產性物料",
};
